export const logoLink = {
    '&&': {
        '& .LogoIcon': {
            display: 'inline-block',
            fontSize: '6rem',
            marginBottom: '0.3rem',
        },
        '& .LogoText': {
            display: 'inline-block',
            fontSize: '1.2rem',
            marginBottom: '0.8rem',
        },
        'color': '$logo',
        'display': 'inline-block',
        'textDecoration': 'none',
    },
}
